import { h, Fragment, Component } from "preact";
import { useEffect, useState, useCallback, useRef } from "react";

export const BuyBar = ({totalResults, childProduct, childProductPrice, lowestPrice}) => {

  return (
    <>
      {totalResults == 1 &&
        <div className="facet-state__buy-bar--wrapper">
          <div className="facet-state__buy-bar">
            <span className="facet-state__buy-bar__title">{window.Resources.currentPageTitle}</span>
            <span className="facet-state__buy-bar__info">
              <span className="facet-state__buy-bar__price">{childProductPrice}</span>
                <a className="facet-state__buy-bar__button button button--primary" href={childProduct.url}>Continue</a>
              </span>
          </div>
        </div>
      }
      
      {totalResults > 1 &&
        <div className="facet-state__buy-bar--wrapper">
          <div className="facet-state__buy-bar">
            <span className="facet-state__buy-bar__title">{window.Resources.currentPageTitle}</span>
            <span className="facet-state__buy-bar__info">
              <span className="facet-state__buy-bar__price">From {lowestPrice}</span>
                <a className="facet-state__buy-bar__button button button--primary disabled" disabled>Please Select Options to Continue</a>
              </span>
          </div>
        </div>
      }
    </>
  )
}